export default "/images/Efficacy.svg?153701f3d6ac6a67208403315abb37bb";